import { IComponentController } from 'angular';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IStateParamsService } from 'angular-ui-router';

interface IPageRe0008 extends IComponentController {
    monoOccurrence: IMonoOccurrence,
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaire: IFormulaire;
}

/* @ngInject */
export default function Re0008Controller(Formulaire: IFormulaireClass,
     FormulaireItem: IFormulaireItemClass,
      $stateParams: IStateParamsService,
      FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {

    const vm: IPageRe0008 = this;

        vm.monoOccurrenceOptions = {
            
            fonctions: {
                importation: false,
                supprime: (data:any) => vm.monoOccurrence.data.vaesysprvret != 'PROD' && data.status,
                afficherMenusDansEntete: true,
                avisEmploye: false
            }
        };
        vm.formulaire = new Formulaire('LBL_PRIME', [
            new FormulaireItem('rtocleint', { largeur: 40, readonly: (data) => data.vaesysprvret === 'PROD' || !data.status && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('demcleintref', { largeur: 40, readonly: (data) => data.vaesysprvret === 'PROD'|| !data.status  && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('aftcleint', { largeur: 40, readonly: (data) => data.vaesysprvret === 'PROD' || !data.status && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('tagcleint', { largeur: 40, readonly: (data) => data.vaesysprvret === 'PROD'|| !data.status  && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('elpdatdeb', { largeur: 20, readonly: (data) => data.vaesysprvret === 'PROD'|| !data.status  && $stateParams.id }),
            new FormulaireItem('elpmnt', { largeur: 20, readonly: (data) => data.vaesysprvret === 'PROD' || !data.status && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('elpdatfin', { largeur: 20, readonly: (data) => data.vaesysprvret === 'PROD'|| !data.status && $stateParams.id  }),
            new FormulaireItem('elppou', { largeur: 20, readonly: (data) => data.vaesysprvret === 'PROD' || !data.status && $stateParams.id }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('elpflgact', { largeur: 20, default: 1, readonly: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('vaesysprvret', { largeur: 20, readonly: true, default: 'RETR' }),
            new FormulaireItem('elpflgina', { largeur: 20, readonly: (data) => data.vaesysprvret === 'RETR' || !data.status && $stateParams.id })
        ]);
}
